import React, { useState } from "react";
import "./Notifications.scss";
import {
  BellIcon,
  TrashIcon,
  FileTextIcon,
  ChevronRightIcon,
} from "../../../../../shared/cockpit/components/icons/Icon";
import {
  LuFlag,
  LuScrollText,
  LuShield,
  LuSettings2,
  LuBox,
} from "react-icons/lu";
 
interface Notification {
  id: number;
  category: string;
  tag: string;
  subTag: string;
  title: string;
  description: string;
  time: string;
  type: "info" | "hint" | "important";
  icon: React.ReactNode;
  unread: boolean;
}
 
function Notifications() {
  const [activeFilter, setActiveFilter] = useState("Alle");
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);
 
  const filters = [
    { name: "Alle", icon: <BellIcon /> },
    { name: "Programm", icon: <LuFlag /> },
    { name: "Prozesse", icon: <LuScrollText /> },
    { name: "Technik", icon: <LuBox /> },
    { name: "Verträge", icon: <FileTextIcon /> },
    { name: "Finanzen", icon: <LuShield /> },
    { name: "System", icon: <LuSettings2 /> },
  ];
 
  const notifications: Notification[] = [
    {
      id: 1,
      category: "Programm",
      tag: "PROGRAMM",
      subTag: "Programm",
      title: "NRW-Pilot: Standort Essen aktiviert",
      description:
        "Der Standort Essen wurde erfolgreich für das Programm freigeschaltet.",
      time: "vor 2 Std.",
      type: "info",
      icon: <LuFlag />,
      unread: true,
    },
    {
      id: 2,
      category: "Programm",
      tag: "PROGRAMM",
      subTag: "Rollout",
      title: "Rollout-Welle 2 gestartet",
      description: "Planungsphase für 5 neue Standorte gestartet.",
      time: "Gestern",
      type: "hint",
      icon: <LuFlag />,
      unread: true,
    },
    {
      id: 3,
      category: "Prozesse",
      tag: "PROZESSE",
      subTag: "Antrag #WB-2025-004",
      title: "Verzögerung: Antrag ohne Freigabe",
      description:
        "Antrag von Mitarbeiterin Y ist seit 10 Tagen ohne Freigabe. Bitte prüfen.",
      time: "vor 4 Std.",
      type: "important",
      icon: <FileTextIcon />,
      unread: true,
    },
  ];
 
  const filteredNotifications = notifications.filter((notif) => {
    const matchesFilter =
      activeFilter === "Alle" || notif.category === activeFilter;
    const matchesUnread = !showUnreadOnly || notif.unread;
    return matchesFilter && matchesUnread;
  });
 
  return (
    <div className="notifications-view">
      <div className="notifications-view__header">
        <div>
          <h1 className="notifications-view__title">Mitteilungen</h1>
        </div>
        <p className="notifications-view__subtitle">
          Alle Benachrichtigungen und Systemhinweise
        </p>
      </div>
 
      <div className="notifications-view__controls">
        <div className="filter-chips">
          {filters.map((filter) => (
            <button
              key={filter.name}
              className={`filter-chip ${activeFilter === filter.name ? "filter-chip--active" : ""}`}
              onClick={() => setActiveFilter(filter.name)}
            >
              {filter.icon} {filter.name}
            </button>
          ))}
        </div>
 
        <div className="unread-toggle">
          <label className="switch">
            <input
              type="checkbox"
              checked={showUnreadOnly}
              onChange={() => setShowUnreadOnly(!showUnreadOnly)}
            />
            <span className="slider round"></span>
          </label>
          <span>Nur ungelesene anzeigen</span>
        </div>
      </div>
 
      <div className="notifications-view__list">
        {filteredNotifications.map((notif) => (
          <div key={notif.id} className="notification-card">
            <div className="notification-card__icon-box">{notif.icon}</div>
 
            <div className="notification-card__main">
              <div className="notification-card__meta">
                <span className="tag">{notif.tag}</span>
                <span className="dot">•</span>
                <span className="subtag">{notif.subTag}</span>
              </div>
 
              <h3 className="notification-card__title">{notif.title}</h3>
              <p className="notification-card__desc">{notif.description}</p>
 
              <div className="notification-card__footer">
                <span
                  className={`status-indicator status-indicator--${notif.type}`}
                >
                  {notif.type === "info" && "Info"}
                  {notif.type === "hint" && "Hinweis"}
                  {notif.type === "important" && "Wichtig"}
                </span>
                <button className="btn-action">
                  Zum Vorgang <ChevronRightIcon />
                </button>
              </div>
            </div>
 
            <div className="notification-card__aside">
              <span className="time">{notif.time}</span>
              <button className="btn-delete">
                <TrashIcon />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
 
export default Notifications;
 
 